import { DocumentConfig } from "src/core/interfaces/Document";
import { getFileExtension } from "src/core/utils/file";

const DEFAULT_DOCUMENT_CONFIG: DocumentConfig = {
  maxContentLength: 1024 * 1024 * 21,
  maxFileNameLength: 512,
  mimeTypes: {
    "image/gif": ["gif"],
    "image/bmp": ["bmp"],
    "image/tiff": ["tiff", "tif"],
    "image/png": ["png"],
    "application/x-tika-msoffice": ["msg"],
    "image/jpeg": ["jpg", "jpeg"],
    "application/pdf": ["pdf"],
  },
  multipleExtensions: true,
  noExtension: false,
};

export const validateDocument = (
  file: File,
  config?: DocumentConfig
): { isValid: boolean; error?: string } => {
  const safeConfig = config ?? DEFAULT_DOCUMENT_CONFIG;

  // Vérification de la taille du fichier
  if (file.size > safeConfig.maxContentLength) {
    return {
      isValid: false,
      error: `Fichier trop volumineux(${Math.round(
        safeConfig.maxContentLength / 1024 / 1024
      )} Mo max)`,
    };
  }

  // Vérification de la longueur du nom de fichier
  if (file.name.length > safeConfig.maxFileNameLength) {
    return {
      isValid: false,
      error: "Nom de fichier trop long.",
    };
  }

  // Vérification du type MIME
  const fileExtension = getFileExtension(file.name);
  if (!fileExtension && !safeConfig.noExtension) {
    return {
      isValid: false,
      error: "Le fichier doit avoir une extension",
    };
  }

  // Vérification qu'il n'y a pas de point avant l'extension
  if (fileExtension) {
    const lastDotIndex = file.name.lastIndexOf(".");
    const fileNameWithoutExtension = file.name.slice(0, lastDotIndex);
    if (fileNameWithoutExtension.includes(".")) {
      return {
        isValid: false,
        error: "Nom de fichier invalide",
      };
    }
  }

  const allowedMimeTypes = Object.entries(safeConfig.mimeTypes);
  const isMimeTypeAllowed = allowedMimeTypes.some(([mimeType, extensions]) => {
    if (file.type === mimeType) {
      return safeConfig.multipleExtensions ? true : extensions.includes(fileExtension ?? "");
    }
    return false;
  });

  if (!isMimeTypeAllowed) {
    return {
      isValid: false,
      error: "Type de fichier non autorisé",
    };
  }

  return { isValid: true };
};
